import {
    defaultFont,
} from "./common-style"

const requisitionStyle = theme => ({
    main: {
        width: "100%",
        margin: "0 auto",
        paddingTop: "50px",
        marginBottom: "20px",
        borderRadius: "8.9px",
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
        backgroundColor: "#ffffff"
    },
    padding: {
        padding: "0px"
    },
    title: {
        
    },
    input: {
        ...defaultFont,
        color: "#AAAAAA !important",
        fontWeight: "300",
        fontSize: "13px",
        lineHeight: "2",
        maxHeight:"50px",
        borderRadius: "5px 5px 5px 5px",
        boxShadow: "rgba(0, 0, 0, 0.35)",
        margin: "15px auto"
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    connectorActive: {
        '& $connectorLine': {
          borderColor: theme.palette.secondary.main,
        },
    },
    connectorCompleted: {
        '& $connectorLine': {
          borderColor: theme.palette.secondary.main,
        },
    },
    connectorDisabled: {
        '& $connectorLine': {
          borderColor: theme.palette.grey[100],
        },
    },
    connectorLine: {
        transition: theme.transitions.create('border-color'),
    },
    stepper: {
        active: {
            '& $MuiStepIcon': {
                color: theme.palette.secondary.main,
              },
        },
        backgroundColor: "#FFFFFF"
    },
    active: {
        color: theme.palette.secondary.main,
    },
    item: {
        margin: "15px 0 0 40px"
    },
    itemValue: {
        margin: "0 0 0 10px"
    },
    next_button: {
        minWidth: "100px",
        textTransform: "none",
        color: "#FFFFFF"
    },
    prev_button: {
        minWidth: "100px",
        textTransform: "none",
        color: "#000000"
    },
    nav_button: {
        minWidth: "100px",
        textTransform: "none",
        marginLeft: 10,
        marginRight: 10
    },
})

export default requisitionStyle